export default __webpack_public_path__ + "static/media/F9067A67-FF45-485B-B3DE-BE8502CE011E.88cad521.jpeg";